import { BreadcrumbsMap } from '../../components/breadcrumbs';

export const tagsBreadcrumbs: BreadcrumbsMap = {
  '/tags': 'Tags',
};
